<div class="d-flex flex-column align-items-center description-text" [class.disabled]="disabled">
  <div [class.disabled]="disabled" i18n>
    <span class="bold-text" [class.disabled]="disabled">Upload a file</span> {{ uploadInstructionText$ | async }}
  </div>
  <div>{{ descriptionText }}</div>
</div>
